import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-64 gap-4 text-center p-6">
          <AlertTriangle className="h-10 w-10 text-amber-500" />
          <div>
            <h2 className="text-lg font-semibold text-slate-800">Cos poszlo nie tak</h2>
            <p className="text-sm text-slate-500 mt-1">Wystapil nieoczekiwany blad. Sprobuj odswiezyc strone.</p>
          </div>
          <Button variant="outline" className="rounded-full gap-2" onClick={() => {
            this.setState({ hasError: false, error: null });
            window.location.reload();
          }}>
            <RefreshCw className="h-4 w-4" /> Odswiez strone
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
